import { useState } from "react";
import { Dialog } from "@mui/material";
import { HStack, Box, ButtonPrimary } from "../../components/utils";
import {
  useGetCompanyPaymentDetails,
  useGetCompanyPaymentProfiles,
} from "../../queries/payment";
import PaymentDetailsDialog from "./PaymentDetailsDialog";
import { formatDisplayDate } from "../../utils/date";

export interface PaymentProfile {
  name: string;
  identifier: string;
  config: { mid?: string; payment_gateway?: string };
  created_at?: string;
  id: string;
}

function PaymentDetails() {
  const { data: paymentDetails } = useGetCompanyPaymentDetails();
  const existingPaymentDetails = paymentDetails ?? [];
  const { data: paymentProfiles } = useGetCompanyPaymentProfiles();
  const [addNewPaymentProfile, setAddNewPaymentProfile] = useState(false);
  const paymentProfileList: PaymentProfile[] = paymentProfiles || [];
  const PaymentDetailsRenderer = (props: { profile: PaymentProfile }) => {
    const { profile } = props;
    return (
      <Box className="p-4 bg-slate-50">
        <HStack className="justify-between">
          <div>
            <h6 className="text-lg font-medium">Name: {profile.name}</h6>
            <p className="text-sm text-gray-500">
              {profile.config.payment_gateway} MID: {profile.config.mid}
            </p>
          </div>
          <div>Created On: {formatDisplayDate(profile.created_at || "")}</div>
        </HStack>
      </Box>
    );
  };
  return (
    <div className="w-full bg-white rounded-md">
      <Box className="px-10 py-4 text-lg font-medium text-left border-b">
        <HStack className="justify-between">
          <HStack className="justify-start">
            <h6>Payment Details</h6>
          </HStack>
          <ButtonPrimary onClick={() => setAddNewPaymentProfile(true)}>
            Add Payment Profile
          </ButtonPrimary>
        </HStack>
      </Box>
      {paymentProfileList.length === 0 && (
        <Box className="p-4 text-gray-500">
          No payment profiles found. Please add a new payment profile.
        </Box>
      )}
      <Box className="p-4 w-1/2 justify-center align-middle">
        {paymentProfileList.map((profile, index) => (
          <PaymentDetailsRenderer key={index} profile={profile} />
        ))}
      </Box>
      {addNewPaymentProfile && (
        <Dialog
          open={addNewPaymentProfile}
          onClose={() => setAddNewPaymentProfile(false)}
        >
          <PaymentDetailsDialog
            onClose={() => setAddNewPaymentProfile(false)}
            mode="create"
          />
        </Dialog>
      )}
    </div>
  );
}

export default PaymentDetails;
